import styled from 'styled-components';
export var Container = styled.div.withConfig({
  displayName: "FilterPropertystyles__Container",
  componentId: "keen-query-creator__sc-1a9u8cp-0"
})(["&&&{position:relative;}"]);
export var DropdownContent = styled.div.withConfig({
  displayName: "FilterPropertystyles__DropdownContent",
  componentId: "keen-query-creator__sc-1a9u8cp-1"
})(["&&&{width:285px;}"]);